import { api } from "@/lib/api";

const SHELL = (title, body) => `<!doctype html><html><head><meta charset="utf-8">
<title>${title}</title><style>
  *{box-sizing:border-box}
  body{font:13px/1.55 "Helvetica Neue",Arial,sans-serif;color:#111827;margin:32px 40px}
  h1{font-size:19px;margin:0 0 2px;color:#3b4fd8;letter-spacing:-0.2px}
  h2{font-size:13px;margin:26px 0 8px;text-transform:uppercase;letter-spacing:.09em;color:#5b6472}
  .muted{color:#5b6472;font-size:11.5px}
  .meta{display:flex;gap:34px;flex-wrap:wrap;margin:18px 0 6px}
  .meta div span{display:block;font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#5b6472}
  table{width:100%;border-collapse:collapse;margin-top:6px}
  th{text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#5b6472;
     border-bottom:1px solid #cfd4dd;padding:7px 6px}
  td{padding:7px 6px;border-bottom:1px solid #e7eaf0;font-size:12px;vertical-align:top}
  td.r,th.r{text-align:right;font-variant-numeric:tabular-nums}
  tfoot td{font-weight:700;border-bottom:none}
  .rule{height:2px;background:#3b4fd8;margin:14px 0 0}
  @media print{body{margin:14mm}}
</style></head><body>${body}
<script>window.onload=function(){window.print()}</script></body></html>`;

export function printHtml(title, body) {
  const w = window.open("", "_blank", "width=900,height=1100");
  if (!w) return false;
  w.document.write(SHELL(title, body));
  w.document.close();
  return true;
}

export async function downloadPdf(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
